import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ConfirmDialog = ({
    isOpen,
    message,
    onConfirm,
    onCancel,
    onClose,
    confirmText = "Продолжить",
    cancelText = "Отмена"
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            size="sm"
            className="confirmation-modal"
            backdrop="static"
        >
            <ModalHeader toggle={onClose}>Подтверждение</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                <Button
                    onClick={onCancel}
                    className="dt1520-button active-dt1520-button default-button"
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    className="dt1520-button active-dt1520-button green-button"
                >
                    {confirmText}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmDialog;